<template>
  <Popover class="absolute inset-0">
    <PopoverButton class="absolute inset-0 flex justify-center items-center" @click="show">
      <EllipsisHorizontalIcon class="h-4 w-4 mr-1" />
    </PopoverButton>

    <transition-appear origin="center">
      <PopoverPanel v-if="isOpened" class="absolute top-[5px] right-[5px] w-screen max-w-max" static>
        <OnClickOutside @trigger="close">
          <div class="isolate inline-flex rounded-md shadow-lg *:first:rounded-l-md *:last:rounded-r-md">
            <a
              v-if="row.deadLetteredAt"
              href="#"
              class="btn-list-action"
              :class="isReplaying ? 'cursor-not-allowed opacity-60' : ''"
              :aria-disabled="isReplaying"
              @click.prevent="onReplay"
            >
              <BoltIcon class="mr-2 h-3 text-slate-400" />
              {{ isReplaying ? 'Replaying...' : 'Replay' }}
            </a>

            <router-link :to="`/stripe-outbox-events?search=${row.eventName}`" class="btn-list-action">
              <FunnelIcon class="mr-2 h-3 text-slate-400" />
              Event
            </router-link>

            <router-link :to="`/stripe-outbox-events?search=${row.userId}`" class="btn-list-action">
              <FunnelIcon class="mr-2 h-3 text-slate-400" />
              User
            </router-link>

            <router-link
              v-if="row.sourceEventId"
              :to="`/stripe-outbox-events?search=${row.sourceEventId}`"
              class="btn-list-action"
            >
              <FunnelIcon class="mr-2 h-3 text-slate-400" />
              Source
            </router-link>

            <router-link :to="`/payment-event-logs?search=${row.id}`" class="btn-list-action">
              <ArrowTopRightOnSquareIcon class="mr-2 h-3 text-slate-400" />
              Payment Log
            </router-link>
          </div>
        </OnClickOutside>
      </PopoverPanel>
    </transition-appear>
  </Popover>
</template>

<script setup>
import { ref, watch } from 'vue';
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue';
import TransitionAppear from './TransitionAppear.vue';
import { EllipsisHorizontalIcon, FunnelIcon, BoltIcon, ArrowTopRightOnSquareIcon } from '@heroicons/vue/24/outline';
import { OnClickOutside } from '@vueuse/components';

const props = defineProps({
  row: {
    type: Object,
    default: () => ({})
  },
  index: {
    type: Number,
    default: null
  },
  isRowHovered: {
    type: Boolean,
    default: false
  },
  isReplaying: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits([ 'replay' ]);

const isOpened = ref(false);

watch(() => props.isRowHovered, val => isOpened.value = val);

function show() {
  isOpened.value = true;
}

function close() {
  isOpened.value = false;
}

function onReplay() {
  if (props.isReplaying) return;
  emit('replay', props.row);
}
</script>
